import { styled } from 'styled-components';

import { Alarm } from 'types';
import { MenuItem, MenuList } from 'components/Menu';

const AlarmTitle = styled.span`
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 6px;
  padding-right: 20px;
`;

const AlarmText = styled.span`
  font-size: 14px;
  line-height: 1;
`;

interface AlarmMenuProps {
  alarms: Alarm[];
  onAlarmCloseClick: (id: string) => void;
}

const AlarmMenu = ({ alarms, onAlarmCloseClick }: AlarmMenuProps) => {
  return (
    <>
      <MenuList>
        <MenuItem disabled>
          <span>알림</span>
        </MenuItem>
      </MenuList>
      <MenuList>
        {alarms.length > 0 ? (
          <>
            {alarms.slice(0, 3).map((alarm) => (
              <MenuItem key={`alarm/${alarm.id}`} onCloseClick={() => onAlarmCloseClick(alarm.id)} disabled>
                <a href="#!">
                  <div>
                    <AlarmTitle>{alarm.title}</AlarmTitle>
                    <AlarmText>{alarm.text}</AlarmText>
                  </div>
                </a>
              </MenuItem>
            ))}
          </>
        ) : (
          <MenuItem disabled padding="20px 18px">
            <span>알림이 없습니다</span>
          </MenuItem>
        )}
      </MenuList>
    </>
  );
};

export default AlarmMenu;
